import Vue from 'vue';
import store from "@/store";
import router from "@/router";

function gjCreate(component, config = {}, modal = true) {

  let comp;
  const vm = new Vue({
    store,
    router,
    // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
    render: h => h (component, {
      name:component.name,
      scopedSlots: config.scopedSlots,
      style: {
        ...config.style
      },
      props: {
        ...config.props,
        visible: false
      },
      on: {
        ...config.on,
        'update:visible': (visible) => {
          if (visible) {
            comp.proxyFalseModalVisible = true;
            comp.proxyTrueModalVisible = true;
          } else {
            comp.proxyFalseModalVisible = true;
            comp.proxyTrueModalVisible = false;
            comp.$gjDestroy();
          }
        }
      },
    })
  }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载

  // 手动获取挂载dom元素
  let mountTo;
  if (config.mountTo) {
    mountTo = config.mountTo;
  } else if (config.global) {
    mountTo = document.getElementById('app');
  } else {
    mountTo = this.$mountTo || this.$el;
  }

  mountTo.appendChild(vm.$el);
  comp = vm.$children[0];

  if (modal) {
    comp.$gjModal = comp;
    comp.$mountTo = mountTo;
    setTimeout(() => {
      comp.modalVisible = true;
    });
  }

  // 回收组件
  comp.$gjDestroy = () => {
    if (modal) {
      comp.proxyFalseModalVisible = false;
      setTimeout(() => {
        if (mountTo.contains(vm.$el)) {
          mountTo.removeChild(vm.$el);
          comp.$destroy();
        }
      }, 200);
    } else {
      if (mountTo.contains(vm.$el)) {
        mountTo.removeChild(vm.$el);
        comp.$destroy();
      }
    }
  };
  return comp;
}

export default gjCreate;
